import React from 'react';
import { useIntl } from 'react-intl';
import { ArrowLeftIcon } from '@panwds/icons';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs.esm.js';
import { Body } from '../Typography/Body.esm.js';
import '@headlessui/react';
import '../../utils/constants.esm.js';
import { Title } from '../Typography/Title.esm.js';
import { Button } from '../Button/Button.esm.js';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';

/**
 * Page header displays the top level page content, including:
 *
 * * Title
 * * Subtitle
 * * Actions
 * * Breadcrumbs
 *
 * ### Import Guide
 *
 * ```jsx
 * import { Button, PageHeader } from "@panwds/react-ui";
 *
 * // Import breadcrumb links from your local Link component
 * // that is connected to your router.
 * import { Link } from 'react-router-dom';
 * ```
 */
function PageHeader({ addClassName, actions, backButton, breadcrumbs, breadcrumb, dataMetrics, dataTestId, icon, iconRight, onClick, subtitle, subtitleSize = "sm", title, }) {
    const className = classNames("tw-p-4 tw-font-lato tw-flex tw-justify-between tw-items-center tw-bg-white dark:tw-bg-gray-1050", addClassName);
    const intl = useIntl();
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || `header-${typeof title === "string" && testIdGen(title)}`, className: className },
        React.createElement("div", { className: "tw-flex tw-flex-col" },
            breadcrumb,
            !breadcrumb && breadcrumbs && React.createElement(Breadcrumbs, null, breadcrumbs),
            React.createElement("div", { className: "tw-flex tw-items-center tw-space-x-1" },
                backButton && (React.createElement(Button, { onClick: onClick, size: "sm", "aria-label": intl.formatMessage({ id: "qjB7lv", defaultMessage: [{ type: 0, value: "Icon-only back button" }] }), icon: React.createElement(ArrowLeftIcon, { size: "sm" }), appearance: "tertiary", addClassName: "tw-mr-4" })),
                icon && React.createElement("div", { className: "dark:tw-text-gray-400" }, icon),
                React.createElement(Title, { level: 1, size: "sm" }, title),
                iconRight && (React.createElement("div", { className: "dark:tw-text-gray-400" }, iconRight))),
            subtitle && (React.createElement(Body, { addClassName: "tw-mt-1 dark:tw-text-[#DADBDB]", appearance: "secondary", size: subtitleSize }, subtitle))),
        actions && React.createElement("div", { className: "tw-flex tw-space-x-1" }, actions)));
}

export { PageHeader };
//# sourceMappingURL=PageHeader.esm.js.map
